export interface IStatus {
  kind: StatusKind
  comment: string
}

export enum StatusKind {
  Viewed = 1,
  Approved = 2,
  Rejected = 3,
}

export function getStatusDisplay(status: StatusKind): string {
  switch (status) {
    case StatusKind.Viewed:
      return 'Просмотрено'
    case StatusKind.Approved:
      return 'Утверждено'
    case StatusKind.Rejected:
      return 'Отклонено'
  }
}

export function getStatusIcon(status: StatusKind): string {
  switch (status) {
    case StatusKind.Viewed:
      return 'mdi-eye-check'
    case StatusKind.Approved:
      return 'mdi-check-all'
    case StatusKind.Rejected:
      return 'mdi-cancel'
  }
}
export function getStatusIconColor(status: StatusKind): string {
  switch (status) {
    case StatusKind.Viewed:
      return 'grey'
    case StatusKind.Approved:
      return 'success'
    case StatusKind.Rejected:
      return 'error'
  }
}
